import { motion } from "framer-motion";
import { Wallet, ShieldCheck, Home } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Wallet,
    title: "Pay Your Deductible",
    body: "You — or your landlord — only pay the deductible from your homeowner's book, and we'll work through it together. That's your only out-of-pocket cost.",
    testid: "process-step-1",
  },
  {
    n: "02",
    icon: ShieldCheck,
    title: "Insurance Pays The Rest",
    body: "We act as your voucher and the middle ground. Once your deductible is covered, the insurance company pays for everything else.",
    testid: "process-step-2",
  },
  {
    n: "03",
    icon: Home,
    title: "Get A Brand-New Roof",
    body: "Our crews get to work. Years of experience on every job — the only thing that's new is the roof we give you.",
    testid: "process-step-3",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-28 md:py-36 bg-hero-surface border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-hero-red mb-4">— How It Works</p>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-2xl">
              Deductible to done<br />in three steps.
            </h2>
          </div>
          <p className="max-w-sm text-hero-silver">A simple, honest process. No surprises — just a new roof over your head.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={s.testid}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group relative bg-hero-void border border-white/10 p-8 rounded-md hover:border-hero-red/60 transition-colors duration-300"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-6xl text-white/10 group-hover:text-hero-red/30 transition-colors duration-300">{s.n}</span>
                <s.icon className="h-8 w-8 text-hero-red" />
              </div>
              <h3 className="font-display uppercase text-2xl mt-6 mb-3">{s.title}</h3>
              <p className="text-hero-silver leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
